import api from "@/lib/api"

/** Sunucuda tutulan kullanıcı arayüz tercihleri: anahtar → değer. */
export type UserPreferences = Record<string, unknown>

export async function fetchUserPreferences() {
  const { data } = await api.get<UserPreferences>("/profile/preferences")
  return data
}

export async function saveUserPreference(key: string, value: unknown) {
  await api.put(`/profile/preferences/${key}`, { value })
}

export async function deleteUserPreference(key: string) {
  await api.delete(`/profile/preferences/${key}`)
}
